import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";

const PHONE = "07523386312";
const PHONE_DISPLAY = "07523 386312";
const WHATSAPP_INTL = "447523386312"; // UK country code, no leading zero

export default function FloatingActions() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.35, ease: [0.76, 0, 0.24, 1] }}
          className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-40 flex flex-col gap-3 pb-[env(safe-area-inset-bottom)]"
          data-testid="floating-actions"
        >
          {/* WhatsApp */}
          <motion.a
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.95 }}
            href={`https://wa.me/${WHATSAPP_INTL}?text=Hi%20Mids%20Tuning%2C%20I%27d%20like%20a%20quote%20on...`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Message Mids Tuning on WhatsApp"
            className="group relative flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-[#25D366] text-black hover:bg-[#128C7E] hover:text-white transition-colors shadow-[0_8px_24px_rgba(37,211,102,0.35)]"
            data-testid="fab-whatsapp"
          >
            <MessageCircle className="w-5 h-5 md:w-7 md:h-7" strokeWidth={2} />
            <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap bg-black text-white font-mono text-[10px] uppercase tracking-widest px-3 py-2 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
              WhatsApp us
            </span>
          </motion.a>

          {/* Call */}
          <motion.a
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.95 }}
            href={`tel:${PHONE}`}
            aria-label={`Call Mids Tuning on ${PHONE_DISPLAY}`}
            className="group relative flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-volt text-black hover:bg-white transition-colors shadow-[0_8px_24px_rgba(204,255,0,0.35)]"
            data-testid="fab-call"
          >
            <Phone className="w-5 h-5 md:w-7 md:h-7" strokeWidth={2} />
            <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap bg-black text-white font-mono text-[10px] uppercase tracking-widest px-3 py-2 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
              Call {PHONE_DISPLAY}
            </span>
          </motion.a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
